import styled from "styled-components";

export const ErrorWrapper = styled.div`
  position: fixed;
  top: 8px;
  left: 0;
  padding: 10px;
  background-color: ${(props: any) => props.theme.colors.red11};
  color: ${(props: any) => props.theme.colors.red5};
  font-weight: 500;
  text-align: center;
  width: 100%;
  z-index: 11;
`;